import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { isClient } from './utils/measure-height';

// Once we ended up on the client, the first render must look the same as on
// the server so hydration happens without problems. _Then_ we immediately
// schedule a subsequent update and return the height measured on the client.
// It's not needed for CSR-only apps, but is critical for SSR.
const useWasRenderedOnClientAtLeastOnce = () => {
  const $ = _c(2);
  const [wasRenderedOnClientAtLeastOnce, setWasRenderedOnClientAtLeastOnce] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (isClient()) {
        setWasRenderedOnClientAtLeastOnce(true);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return wasRenderedOnClientAtLeastOnce;
};
export default useWasRenderedOnClientAtLeastOnce;